/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const FileDigit = [
  [
    "path",
    {
      d: "M4 12V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
  ["path", { d: "M10 16h2v6" }],
  ["path", { d: "M10 22h4" }],
  ["rect", { x: "2", y: "16", width: "4", height: "6", rx: "2" }]
];

export { FileDigit as default };
//# sourceMappingURL=file-digit.js.map
